import { defineAction } from '~/prix'
import { z } from 'zod'
import waterSourceApplicationFetchAction from './waterSourceApplicationFetch.action.json' with { type: 'json' }
import { waterSourceApplicationObject } from '../waterSourceApplicationObject'

const waterSourceApplicationFetchDefinition = defineAction({
  ...waterSourceApplicationFetchAction,

  input: z.object({ id: z.string().uuid() }),
  output: waterSourceApplicationObject,
})

export default waterSourceApplicationFetchDefinition
